import { DownloadDataInput, downloadData } from 'aws-amplify/storage';

const storageGet = ({ key, options }: DownloadDataInput) => downloadData({ key, options }).result;

export default storageGet;
